import React, { memo } from 'react';
import { View } from 'react-native';
import SubscriptionHeader from './transactions/SubscriptionHeader';
import InactiveSubscriptionHeader from './InactiveSubscriptionHeader';
import SubscriptionPrediction from './transactions/SubscriptionScreenHeader';
import { useSubscriptionScreenContext } from '../context/subscriptionScreenContext';
const SubscriptionScreenListHeader = ({ onEdit, onDone, editPrediction, addPrediction, onCancel, onSkip, onAlreadyPaid, isCancelling, noMarginHorizontal, }) => {
    const { data: subscription, hasData, name } = useSubscriptionScreenContext();
    if (!(subscription && subscription.predictions))
        return null;
    const { predictions, id, isActive } = subscription;
    if (!isActive) {
        return (<InactiveSubscriptionHeader name={name} hasData={hasData} subscription={subscription}/>);
    }
    return (<View>
      <SubscriptionHeader subscription={subscription} noMarginHorizontal={noMarginHorizontal}/>
      <SubscriptionPrediction date={predictions[0]?.date} subscriptionId={id} onPress={editPrediction} onAdd={addPrediction} onEdit={onEdit} onDone={onDone} onCancel={onCancel} onSkip={onSkip} onAlreadyPaid={onAlreadyPaid} isCancelling={isCancelling} subscription={subscription} noMarginHorizontal={noMarginHorizontal}/>
    </View>);
};
export default memo(SubscriptionScreenListHeader);
